import { Button, Checkbox, Input, Modal, notification } from "antd";
import backIcon from "../../Assets/images/back-icon.svg";
import platformSubscriptonFeeIcon from "../../Assets/images/platform-subscription-fee.svg";
import ViewPdfModal from "../ViewPdfModal";
import "./style.css";
import { useEffect, useState } from "react";

const pdfUrl = "https://plunes-data.s3.ap-south-1.amazonaws.com/terms-and-condition/HIMS-LIST-OF-FEATURES.pdf";

export default function TermsConditionsModal({
  termsChecked,
  setTermsChecked,
  platformSubscriptonFee,
  representativeName,
  setRepresentativeName,
  representativeDesignation,
  setRepresentativeDesignation,
  hospitalData,
  setVisibleModal,
}) {
  const [viewPdfModal, setViewPdfModal] = useState(false);
  const [openTermsConditionModal, setOpenTermsConditionModal] = useState(true)
  // console.log("terms and condition modal plarform fee", platformSubscriptonFee);
  // console.log("hospitalData", hospitalData);

  // useEffect(() => {
  //   if(hospitalData) {
  //     setRepresentativeDesignation(hospitalData?.representativeDesignation)
  //     setRepresentativeName(hospitalData?.representativeName)
  //   }
  // }, [hospitalData])

  const handleNext = () => {
    if(!representativeName) {
      notification.error({
        message: "Error",
        description: "Please enter representative name before proceed."
      })
      return
    }
    if(!representativeDesignation) {
      notification.error({
        message: "Error",
        description: "Please enter representative designation before proceed."
      })
      return
    }
    if(!termsChecked) {
      notification.error({
        message: "Error",
        description: "Please check the terms before proceed."
      })
      return
    }
    setOpenTermsConditionModal(false)
    setVisibleModal('basicDetails')
  }

  return (
    <>
      <Modal
        width={"80%"}
        //   title="Hospital TARIFF"
        title={null}
        closable={false}
        open={openTermsConditionModal}
        className="claim-status-modal"
        // onCancel={() => setOpenTermsConditionModal(false)}
        bodyStyle={{ padding: "0" }}
        footer={[
          <Button
            style={{
              fontSize: "1.1rem",
              fontWeight: "700",
              color: "white",
              padding: "0.5rem 3.75rem",
              border: 'none',
              backgroundColor: "rgba(0, 168, 46, 1)",
              borderRadius: "5px",
              height: "auto",
              boxShadow: "0px 4px 8px 0px #C0C0C0",
              margin: '1rem 8rem 1.5rem 0'
            }}
            key="back"
            onClick={() => handleNext()}
          >
            Next
          </Button>,
        ]}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            backgroundColor: "rgba(62, 151, 255, 1)",
            color: "white",
            padding: "0.6rem 1.5rem",
          }}
        >
          {/* <img
            width={26}
            height={20}
            src={backIcon}
            alt=""
            style={{ filter: "invert(1)", cursor: 'pointer' }}
            onClick={() => setOpenTermsConditionModal(false)}
          /> */}
          <div style={{ fontSize: "1.25rem", fontWeight: "600" }}>
            Terms & Conditions
          </div>
        </div>
        <div
          style={{
            fontSize: "2rem",
            fontWeight: "600",
            textAlign: "center",
            marginTop: "3rem",
            marginBottom: "2rem",
          }}
        >
          Terms & Conditions
        </div>
        <div
          className="terms-text"
          style={{
            // width: "70%",
            padding:'0 8rem',
            maxWidth: "1400px",
            margin: "auto",
            textAlign: "justify",
            fontWeight: "400",
            fontSize: "1rem",
          }}
        >
          <p>
            We are AWC Technologies Private Limited ('operating under brand
            names
            <b> Plunes</b>', &#39;<b>Company</b>&#39;, or &#39;<b>We</b>&#39;),
            a company registered in India under the Companies Act, 2013, having
            the CIN - U74999DL2016PTC304426 and its registered office at 55, 2nd
            Floor Lane No. 2, West End Marg, Saidulajab, Near Saket Metro
            Station, New Delhi - 110030, India.
          </p>
          <p>
            We are, <i>inter alia</i>, engaged in the business of (a) providing
            access to this portal which is a proprietary health technology
            platform (the '<b>Portal</b>') and other software solutions to the
            users of this Portal for hospital information management system.
            patient management; and (b) insurance claim management. We operate
            our business and provide the Services under the brand name of 
            '<b>Plunes</b><svg 
              width="12" 
              height="12" 
              viewBox="0 0 12 12" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              style={{ 
                marginLeft: '1px',
                verticalAlign: 'super'
              }}
            >
              <circle cx="6" cy="6" r="5.65" stroke="black" strokeWidth="0.7"/>
              <path d="M5.01159 4.6496V5.192H4.11879V8H3.44679V5.192H2.55399V4.6496H5.01159ZM9.4547 4.6496V8H8.7827V5.8208L7.8851 8H7.3763L6.4739 5.8208V8H5.8019V4.6496H6.5651L7.6307 7.1408L8.6963 4.6496H9.4547Z" fill="black"/>
            </svg>' which is owned and operated by the Company. Any use of or
            reference to 'Plunes' in this Terms of Use shall mean the business
            of the Company conducted under the brand name of '<b>Plunes</b>'
            including providing the Services.
          </p>
          <p>
            We are providing the Services to You in accordance with the Terms of
            Use set out below and as per the commercial arrangement agreed and
            accepted by You.
          </p>
          <p>
            These Terms of Use constitute a legally binding agreement between
            You, whether personally or on behalf of an entity (&#39;<b>You</b>
            &#39;), and the Company, concerning your access to and use of the
            Services. You agree that by accessing the Services, You have read,
            understood, and agreed to be bound by all of these Terms of Use. If
            You do not accept all of these Terms of Use, You are expressly
            prohibited from using the Services and must cease use immediately.
          </p>
          <p>
            We will provide You with prior notice of any scheduled changes to
            the Services You are using. The modified Terms of Use will become
            effective upon notifying You from our email, hospitalsupport@plunes.com, as
            stated in the email message. By continuing to use the Services after
            the effective date of any changes, You agree to be bound by the
            modified terms.
          </p>
          <p className="terms-heading">1. OUR SERVICES</p>
          <p>
            1.1 The Services provided on the Portal are intended to improve your
            Hospital Operations and digitization of the patient journey. Our
            Portal is a cloud based HIMS solution using which you can get
            operational intelligence for incremental patient volumes and better
            business outcomes. Plunes endeavours to improve its Portal users’
            patient base via this portal and will help in streamlining the
            users’ operations. You will be listed on the Plunes website and the
            mobile applications, and Plunes will promote You on its application,
            website.
          </p>
          <p>
            1.2 Subject to the agreed commercial arrangement, Plunes is
            providing You access to the Portal with its functionalities and
            features, i.e. Cloud based HIMS system, analytics panel, mobile
            applications and Digital Payment Accounts.
          </p>
          <p>
            List of HIMS Features{" "}
            <b>
              <a onClick={() => setViewPdfModal(true)}><u>View</u></a>
            </b>{" "}
          </p>
          <p>
            1.3 These Terms of Use shall remain in full force and effect while
            You use the Services. You may terminate your access to the Services
            by giving to Plunes a sixty (60) days prior written notice.
            Similarly, Plunes may terminate your access to the Services by
            giving You a sixty (60) days prior written notice.
          </p>
          <p className="terms-heading">
            2. USER REQUIREMENTS FOR USE OF SERVICES
          </p>
          <p>
            2.1 You must provide all materials required to educate patients
            about your facilities, treatment options, standard of care, pricing
            of procedures etc., to Plunes.
          </p>
          <p>
            2.2 You must provide, to Plunes, treatment data, pricing, and
            related materials for each case on priority within 24 hours of the
            request made by Plunes.
          </p>
          <p>
            2.3 You are required to appoint one (1) point of contact for
            coordination with Plunes. You must also provide customer care
            facility.
          </p>
          <p>
            2.4 You must, on need basis, share the list of treatments You
            conduct along with the price and other details as may be reasonably
            requested by Plunes.
          </p>
          <p>
            2.5 You must provide best price to the users of Plunes’ portals and
            to patients who provide booking ID received from Plunes at the time
            of booking and/or making payment for the treatment availed from You.
          </p>
          <p className="terms-heading">3. DIGITAL PAYMENT ACCOUNTS</p>
          <p>
            3.1 Claim amount will be settled by the insurance company within
            maximum 30 business days on best effort basis. The period stated in
            this paragraph will begin from the day all required claim documents
            as submitted by You have been duly received by the insurance company
            and Plunes. The payment of the claim settlement amount will be
            contingent upon verification, by Plunes or the insurance company, of
            the claim documents submitted by You.
          </p>
          <p>
            3.2 The payment for settlement of claims will in no way absolve You
            of your duty to comply with the procedural and documentary
            requirements necessary for claim processing. Notwithstanding the
            payment for settlement of claims under paragraph 3.1, Plunes, with
            the specific instructions of the insurance company, may determine
            whether any payment is appropriate under the circumstances and
            reserves the right to withhold such payment if Plunes believes there
            are any discrepancies, inaccuracies, or omissions in the claim
            documentation submitted by You.
          </p>
          <p>
            3.3 Upon receiving written intimation from Plunes of the rejection
            or reversal of the claim by the insurance company, You must repay
            the full amount received against settlement of claim/s by You for
            the rejected or reversed claim, to the insurance company within such
            time period as may be specified by the insurance company in its
            intimation of rejection/demand for refund.
          </p>
          <p>
            3.4 In the event of a dispute regarding the rejection or reversal of
            a claim under paragraph 3.3, You agree to cooperate with Plunes in
            good faith to resolve the issue with the insurance company.
          </p>
          <p>
            3.5 You agree to furnish a No Dues Certificate{" "}
            <b>
              <a
                href="https://plunes-data.s3.ap-south-1.amazonaws.com/terms-and-condition/NO-DUES-CERTIFICATE.docx"
                target="_blank"
              >
                (<u>NDC</u>)
              </a>
            </b>{" "}
            to Plunes and the insurance company in the manner prescribed here,
            to certify that there is no payment due from Plunes or the insurance
            company to You for patients admitted and processed by You through
            Plunes. This NDC must be furnished by You on a quarterly basis. For
            the purposes of this Terms of Use, a &#39;quarter&#39; means a
            successive period of three months ending on 30<sup>th</sup> June, 30
            <sup>th</sup> September, 31<sup>st</sup> December and 31
            <sup>st</sup> March each year.
          </p>
          <p className="terms-heading">4. FEES FOR THE SERVICES</p>
          <p>
            4.1 By accepting these Terms of Use or continuing to use our
            Services, You agree to following payment terms: Platform
            subscription fees is to be entered below:
          </p>
          <div
            style={{
              border: "1px solid rgba(193, 189, 189, 1)",
              borderRadius: "8px",
              padding: "1rem",
              display: "flex",
              justifyContent: "space-between",
              marginTop: "2rem",
              marginBottom: "2rem",
              maxWidth: "700px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: "0.5rem",
                fontWeight: "600",
              }}
            >
              <img
                width={24}
                height={24}
                src={platformSubscriptonFeeIcon}
                alt=""
              />
              <div>Subscription Fee*</div>
            </div>
            <div
              style={{
                display: "flex",
                gap: "0.5rem",
              }}
            >
              <Input
                style={{
                  width: "10rem",
                  border: "none",
                  borderRadius: "12px",
                  backgroundColor: "rgba(240, 240, 240, 1)",
                  fontSize: "1rem",
                  padding: "0.3rem 8px",
                }}
                value={platformSubscriptonFee}
                type="number"
                onWheel={(e) => e.currentTarget.blur()}
                readOnly
              />
            
              <div
                style={{
                  width: "fit-content",
                  color: "rgba(207, 207, 207, 1)",
                  border: "none",
                  borderRadius: "12px",
                  backgroundColor: "rgba(240, 240, 240, 1)",
                  fontSize: "1rem",
                  padding: "0.2rem 0.8rem",
                  fontWeight: "900",
                  fontSize: "1.25rem",
                }}
              >
                %
              </div>
            </div>
          </div>
          <p>
            4.2 The details regarding the applicable subscription fee, portal
            fee percentage, and payment methods will be provided to You at the
            time of subscription which is available in your profile and may be
            updated in accordance with our policies.
          </p>
          <p>
            4.3 The subscription fee will always be invoiced in full, and You
            agree that You will have no right to refund in case the subscription
            is terminated before the end of the month for which the subscription
            fee has been paid.
          </p>
          <p>
            4.4 If a payment is processed online at the Platform, the same will
            be adjusted at the time of reconciliation.
          </p>
          <p>
            4.5 You must be duly registered and in compliance with all the
            provisions of goods and service tax, and such other applicable
            duties, charges, and levies, and provide all such information to
            Plunes. You must also comply with all procedural formalities
            prescribed by the applicable laws and/or statutes for raising the
            invoice (including but not limited to uploading the data as regards
            invoices / any other documents evidencing the payments, in a correct
            form and in line with the prescribed law and rules thereunder).
          </p>
          <p>
            4.6 You agree that Plunes has the right to deduct tax deducted at
            source (TDS) and charge goods and service tax as per applicable
            laws.
          </p>
          <p>
            4.7 Plunes adheres to transparent module of payments, where our
            partner facilities can easily track the status of the payment in the
            panels offered to them.
          </p>
          <p>
            4.8 Our partner facilities have the complete control in adding the
            amount, i.e., the price of the service, discount offerings, and also
            can easily track the status of the payments.
          </p>
          <p>
            4.9 We may, from time to time, make changes to the subscription fee
            and will communicate any price changes to You in advance in
            accordance with applicable laws.
          </p>
          <p className="terms-heading">5. INTELLECTUAL PROPERTY RIGHTS</p>
          <p>
            We are the owner of all intellectual property rights in our
            Services, including all source code, databases, functionality,
            software, website designs, audio, video, text, photographs, and
            graphics in the Services, as well as the trademarks, service marks,
            and logos contained therein (collectively, the &#39;IPR&#39;).
          </p>
          <p>
            The IPR are provided in or through the Services &#39;AS IS&#39; for
            your internal business purpose only. Any present and future
            intellectual property rights created during activities under this
            Terms of Use will be solely owned by Plunes.
          </p>
          <p>
            Any breach of these IPR will constitute a material breach of our
            Terms of Use and your right to use our Services will terminate
            immediately.
          </p>
          <p className="terms-heading">6. USER REPRESENTATIONS</p>
          <p>
            By using the Services, You represent and warrant that: (1) all
            registration information You have submitted or will submit are true,
            accurate, current, and complete; (2) You will maintain the accuracy
            of such information and promptly update such registration
            information as necessary; (3) You have the legal capacity and You
            agree to comply with these Terms of Use; (4) You will not use the
            Services for any illegal or unauthorised purpose; and (5) your use
            of the Services will not violate any applicable laws or regulations.
          </p>
          <p>
            If You provide any information that is untrue, inaccurate, not
            current, or incomplete, We have the right to suspend or terminate
            your account and refuse any and all current or future use of the
            Services (or any portion thereof).
          </p>
          <p className="terms-heading">7. INDEMNITY</p>
          <p>
            7.1 You and Plunes agree to defend, indemnify, and hold each other
            harmless and their officers, directors, employees, and agents from
            and against any and all liabilities, claims, suits, losses, damages,
            costs, fees and expenses (including reasonable attorneys&#39; fees)
            arising out of or in connection with (a) any non- compliance with
            applicable laws by them in performance of their obligations under
            the Agreement.
          </p>
          <p>
            7.2 Plunes will not be held responsible for any medico-legal
            liability arising from complications in the treatments of patients
            which is conducted under the supervision of your doctors or medical
            staff.
          </p>
          <p>
            7.3 Any liability herein will not be more than three (3) months of
            the aggregate platform fee to be received by Plunes from You for the
            Services.
          </p>
          <p>
            7.4 Neither Plunes nor You will be liable for any indirect,
            consequential, exemplary, or punitive damages, including lost
            profits, loss of business, and/ or goodwill.
          </p>
          <p className="terms-heading">8. SOFTWARE</p>
          <p>
            We may include software for use in connection with our Services. If
            such software is accompanied by an end user licence agreement
            (&#39;EULA&#39;), the terms of the EULA will govern your use of the
            software. If such software is not accompanied by a EULA, then We
            grant to You a non-exclusive, revocable, personal, and
            non-transferable licence to use such software solely in connection
            with our Services and in accordance with these Terms of Use. Any
            software and any related documentation is provided &#39;AS IS&#39;
            without warranty of any kind, either express or implied, including,
            without limitation, the implied warranties of merchantability,
            fitness for a particular purpose, or non-infringement. You accept
            any and all risk arising out of use or performance of any software.
            You may not reproduce or redistribute any software except in
            accordance with the EULA or these Terms of Use.
          </p>
          <p className="terms-heading">9. CONFIDENTIALITY</p>
          <p>
            9.1 &quot;Confidential Information&quot; means any non-public
            information, data, or materials disclosed by either Party (Plunes or
            You) to the other Party in connection with these Terms of Use,
            whether orally, in writing, or in electronic form. Confidential
            Information includes, but is not limited to, proprietary business
            information, financial data, technical know-how, trade secrets,
            intellectual property, user/patient records, operational processes,
            marketing strategies, and any information marked as
            &#39;confidential&#39; or disclosed under circumstances that
            reasonably indicate its confidential nature.
          </p>
          <p>
            9.2 During the term of use of the Portal and the Services, and
            thereafter, the Parties (“Receiving Party”) shall treat as
            confidential and shall not disclose to any third party or use for
            any purpose other than the performance of its obligations under
            these Terms of Use, any Confidential Information received from the
            other Party (“Disclosing Party”). The Parties shall take reasonable
            measures to protect Confidential Information from unauthorized use
            or disclosure.
          </p>
          <p>
            9.3 Notwithstanding the foregoing, the Parties may disclose
            Confidential Information to its employees, agents, contractors, and
            advisors who have a legitimate need to know such information for the
            purpose of carrying out the obligations under these Terms of Use,
            provided that such persons are bound by confidentiality obligations
            no less restrictive than those set forth in these Terms of Use.
          </p>
          <p>
            9.4 The obligations of confidentiality shall not apply to
            Confidential Information that: (a) is or becomes publicly available
            through no fault of the Receiving Parties; (b) was lawfully in the
            possession of the Receiving Party prior to disclosure by the
            Disclosing Party; (c) is rightfully obtained by the Receiving Party
            from a third-party without breach of any confidentiality obligation;
            or (d) is independently developed by the receiving Party without use
            of the Disclosing Party’s Confidential Information.
          </p>
          <p>
            9.5 Upon the written request of the Disclosing Party, or upon the
            termination of your access to the Services and/or the Portal, the
            Receiving Party shall promptly return or destroy all tangible and
            electronic copies of the Disclosing Party’s Confidential Information
            in its possession or control.
          </p>
          <p>
            9.6 The Parties acknowledge and agree that a breach or threatened
            breach of this confidentiality clause may cause irreparable harm to
            the Disclosing Party, for which monetary damages alone may not be an
            adequate remedy. In such cases, the Disclosing Party shall be
            entitled to seek injunctive relief or equitable remedies in addition
            to any other remedies available at law or in equity.
          </p>
          <p>
            9.7 The obligations of confidentiality set forth in this paragraph
            shall survive the termination of your access to the Services and/or
            the Portal for a period of two (2) years, except for trade secrets,
            which shall be protected for as long as they remain trade secrets
            under applicable law.
          </p>
          <p className="terms-heading">10. MODIFICATIONS AND INTERRUPTIONS</p>
          <p>
            We reserve the right to change, modify, or remove the contents of
            the Services at any time or for any reason at our sole discretion
            with a prior written notice to You.
          </p>
          <p>
            We cannot guarantee that the Services will be available at all
            times. We may experience hardware, software, or other problems or
            need to perform maintenance related to the Services, resulting in
            interruptions, delays, or errors. You agree that we have no
            liability whatsoever for any loss, damage, or inconvenience caused
            by your inability to access or use the Services during any downtime
            for any reason.
          </p>
          <p className="terms-heading">11. GOVERNING LAW</p>
          <p>
            These Terms of Use shall be governed in all respects by the laws of
            India and the courts at Delhi, India shall have exclusive
            jurisdiction.
          </p>
          <p className="terms-heading">12. DISPUTE RESOLUTION</p>
          <p>
            12.1 In the event a dispute arises in connection with the
            interpretation or implementation of these Terms of Use, such dispute
            shall be referred to a mutually appointed sole arbitrator according
            to the Arbitration and Conciliation Act, 1996 (India), as amended
            from time to time, and the rules made thereunder. Arbitration will
            be conducted in Delhi, India under governing law stated in paragraph
            11 above.
          </p>
          <p>
            12.2 All proceedings in any such arbitration shall be conducted in
            English.
          </p>
          <p>
            12.3 The arbitration award shall be final and binding, and You agree
            to be bound by the award and to act accordingly.
          </p>
          <p>
            12.4 The arbitrator may, (but shall not be required to), award to a
            party that substantially prevails on merits, its costs, and
            reasonable expenses (including reasonable fees of its counsel).
          </p>
          <p>
            12.5 When any dispute is under arbitration, except for the matters
            under dispute, both Plunes and You will continue to exercise their
            remaining respective rights and fulfil their remaining respective
            obligations under these Terms of Use.
          </p>
          <p className="terms-heading">13. CORRECTIONS</p>
          <p>
            There may be information on the Services that contains typographical
            errors, inaccuracies, or omissions, including descriptions, pricing,
            availability, and various other information. We reserve the right to
            correct any errors, inaccuracies, or omissions and to change or
            update the information on the Services at any time, without prior
            notice.
          </p>
          <p className="terms-heading">14. USER DATA</p>
          <p>
            We will maintain certain data that You transmit to the Services for
            the purpose of managing the performance of the Services, as well as
            data relating to your use of the Services. Although we perform
            regular routine backups of data, You are solely responsible for all
            data that You transmit or that relates to any activity You have
            undertaken using the Services. You agree that we shall have no
            liability to You for any loss or corruption of any such data, and
            You hereby waive any right of action against us arising from any
            such loss or corruption of such data.
          </p>
          <p className="terms-heading">15. MISCELLANEOUS</p>
          <p>
            These Terms of Use and any policies or operating rules posted by us
            on the Services or in respect to the Services constitute the entire
            agreement and understanding between You and us. Our failure to
            exercise or enforce any right or provision of these Terms of Use
            shall not operate as a waiver of such right or provision. These
            Terms of Use operate to the fullest extent permissible by law. We
            may assign any or all of our rights and obligations to others at any
            time. We shall not be responsible or liable for any loss, damage,
            delay, or failure to act caused by any cause beyond our reasonable
            control. If any provision or part of a provision of these Terms of
            Use is determined to be unlawful, void, or unenforceable, that
            provision or part of the provision is deemed severable from these
            Terms of Use and does not affect the validity and enforceability of
            any remaining provisions. There is no joint venture, partnership,
            employment or agency relationship created between You and us as a
            result of these Terms of Use or use of the Services. You hereby
            waive any and all defences You may have based on the electronic form
            of these Terms of Use and the lack of signing by the parties hereto
            to execute these Terms of Use.
          </p>
          <p className="terms-heading">16. CONTACT US</p>
          <p>
            In order to resolve a complaint regarding the Services or to receive
            further information regarding use of the Services, please contact us
            at:
          </p>
          <p style={{ marginBottom: "0" }}>
            <b>Email</b>: hospitalsupport@plunes.com
          </p>
          <p style={{ marginBottom: "0" }}>
            <b>Phone Number</b>: +91-9354 277 013
          </p>
          <p>
            <b>Address</b>: Plot no. 90B, Delhi - Jaipur Expressway, Sector 18, Gurugram, Haryana 122008
          </p>

          <Checkbox
            value={termsChecked}
            checked={termsChecked}
            onChange={(e) => setTermsChecked(e.target.checked)}
            style={{ marginBottom: "2rem", marginTop: "2rem" }}
          >
            <p
              style={{
                margin: "0px",
                fontWeight: "600",
                fontSize: "1rem",
              }}
            >
              <span>I</span>{" "}
              <Input
                value={representativeName}
                onChange={(e) => setRepresentativeName(e.target.value)}
                className="inline-input"
                placeholder="Name"
              />
              <span>, working as</span>{" "}
              <Input
                value={representativeDesignation}
                onChange={(e) => setRepresentativeDesignation(e.target.value)}
                className="inline-input"
                placeholder="Designation"
              />{" "}
              <span>in</span>{" "}
              <Input
                // className="inline-input"
                placeholder="Name of the Hospital"
                style={{ width: "200px" }}
                value={hospitalData.name}
                className="inline-input"
                disabled
                // readOnly
              />
              {", "}
              <span>
                hereby declare that I have read, understood, and agree to abide
                by all the aforementioned
              </span>{" "}
              <span>
                Terms & Conditions.
              </span>
              *
            </p>
          </Checkbox>
          <p style={{ 
                fontSize: '0.875rem', 
                color: '#3E97FF', 
                marginTop: '0.5rem',
                
              }}>
                (* This field is mandatory)
              </p>
        </div>
      </Modal>
      {viewPdfModal && (
        <ViewPdfModal
          openPDFModal={viewPdfModal}
          pdfUrl={pdfUrl}
          setOpenPDFModal={setViewPdfModal}
        />
      )}
    </>
  );
}
